export const ErrorComponent = (props: any) => {
    return (<h1 className="error-message">{props.msg}</h1>);
}
